import { PartnersFieldsService } from './../core/partners-fields.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';
import { PartnersService } from 'src/app/_services/partners.service';
import { MessageService } from 'primeng/api';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-partner-all-improved',
  templateUrl: './partner-all-improved.component.html',
  styleUrls: ['./partner-all-improved.component.scss'],
  providers: [DatePipe, MessageService],
})
export class PartnerAllImprovedComponent implements OnInit, OnDestroy {
  partners: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };
  subscriptions: Subscription[] = [];
  loading = false;

  form: FormGroup;

  constructor(
    private partnersService: PartnersService,
    public fieldsService: PartnersFieldsService,
    private datePipe: DatePipe,
    private messService: MessService,
    private fb: FormBuilder
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */

  ngOnInit(): void {
    this.form = this.fb.group({
      company: '',
      contact: '',
    });

    this.getAll();

    this.form.valueChanges.pipe(debounceTime(300)).subscribe((filters) => {
      if (filters !== null) {
        this.getAll(1, 10, this.createQueryString(filters));
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getAll(pageIndex = 1, perPage = 100, queryParams = '') {
    this.loading = true;

    this.partnersService
      .getAll(pageIndex, perPage, queryParams)
      .subscribe((responseData) => {
        this.partners.data = responseData.data;

        this.partners.pagination = responseData.pagination;
        this.loading = false;
      });
  }

  onDelete(data: { event: Event; id: number }) {
    this.subscriptions.push(
      this.partnersService.delete(data.id).subscribe({
        next: (res: any) => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno',
            detail: 'Ušpesno ste obrisali stavku',
          });

          this.getAll();
        },
        error: (err) => {
          this.messService.add({
            severity: 'error',
            title: 'Greška',
            detail: 'Došlo je do greške',
          });
        },
      })
    );
  }

  /* ====================================
 *                HELPERS
 ======================================= */

  onPageChange(event: any) {
    this.getAll(event.page + 1, event.rows);
  }

  onResetFilter() {
    this.form = this.fb.group({
      company: '',
      contact: '',
    });

    this.getAll();
  }

  createQueryString(form) {
    const query = new URLSearchParams(form).toString().replace('null', '');
    return query;
  }
}
